// extracted by mini-css-extract-plugin
export default {"tabletBreakpoint":"500px","desktopBreakpoint":"1000px","mobile":"(max-width: 500px)","tablet":"(min-width: 501px) and (max-width: 1000px)","desktop":"(min-width: 1001px)"};